const loaderSettings = {
    message: 'loading...',
    foregroundStyle : {
        color: '#3A3A3A'
    },
    backgroundStyle : {
        backgroundColor: '#F2F2F2',
        opacity: '.7'
    }
};
export default loaderSettings;



// WEBPACK FOOTER //
// ./app/styles/loaderSettings.js